module.exports = __webpack_public_path__ + "img/select2.a0aef19c.png";